import { useEffect, useState } from "react";
import { IDP } from "@maxeb/idp-sdk";
let timeoutId = null;
let MOUNTED = false;
const renewalTime = 1800000; // 30min * 60s * 1000ms
async function whoAmI(setState) {
    try {
        const response = await IDP.whoAMI();
        if (MOUNTED && response.isSuccess()) {
            const session = response.getResult().data;
            if (session)
                timeoutId = setTimeout(() => whoAmI(setState), renewalTime);
            return setState(response.getResult().data);
        }
    }
    catch (err) {
        console.error(err);
    }
    if (MOUNTED)
        return setState(null);
}
export default function useSession(session) {
    const stateArray = useState(session);
    const [state, setState] = stateArray;
    useEffect(() => {
        MOUNTED = true;
        if (state)
            timeoutId = setTimeout(() => whoAmI(setState), renewalTime);
        return () => {
            MOUNTED = false;
            if (timeoutId)
                clearTimeout(timeoutId);
        };
    }, [state]);
    return stateArray;
}
